import React from 'react';
import {FormattedMessage} from 'react-intl';
import {createSelector} from 'reselect';

import {DISCLOSURE_IDS} from '@stubhub/disclosure-utils';
import {determineIsTrader} from '@stubhub/trader-helpers';

import {eventCountryCodeSelector, eventCurrencySelector} from '../../../../../../store/event/selectors';
import {showBrokerInfoDSASelector, showBrokerInfoSelector} from '../../../../../../store/gsConfig/FF/selectors';

const listingSelector = ({buildyourorder}) => buildyourorder?.listing || {};
const proSellerInfoSelector = createSelector(listingSelector, (listing) => listing.proSellerInfo || {});
const complianceSelector = ({buildyourorder}) => buildyourorder?.compliance || {};
const traderSelector = createSelector(proSellerInfoSelector, (sellerInfo) => sellerInfo.sellerName);
const ticketTraitsSelector = createSelector(listingSelector, (listing) => listing && listing.ticketTraits);

const ticketTraitsConvertSelector = createSelector(ticketTraitsSelector, (ticketTraits) => {
  if (!ticketTraits || ticketTraits.length === 0) {
    return [];
  }
  const ticketConverted = ticketTraits.map((trait, idx) => {
    return {
      key: `ticketTrait${idx}`,
      info: trait.name,
      id: trait.id,
      type: trait.type,
    };
  });

  return ticketConverted;
});

const traderContentSelector = createSelector(
  traderSelector,
  showBrokerInfoSelector,
  showBrokerInfoDSASelector,
  complianceSelector,
  proSellerInfoSelector,
  eventCountryCodeSelector,
  eventCurrencySelector,
  (
    trader,
    showBrokerIcon,
    showBrokerIconDSA,
    {isCma, isDsa, isDsaAccepted, sellerTypes, firstName, lastName, companyName},
    {sellerType},
    eventCountry,
    eventCurrency
  ) => {
    const isTrader = determineIsTrader(
      showBrokerIconDSA,
      showBrokerIcon,
      isCma,
      isDsa,
      isDsaAccepted,
      sellerType,
      eventCountry,
      eventCurrency
    );

    const traderName = showBrokerIcon
      ? trader
      : sellerTypes?.includes('TRADER')
      ? `${firstName} ${lastName}`
      : companyName;

    return (
      isTrader && {
        key: 'trader',
        info: (
          <FormattedMessage
            id="byo.ticket.seller"
            defaultMessage="The seller of these tickets is a trader: {trader}"
            values={{trader: traderName}}
          />
        ),
        id: DISCLOSURE_IDS.SELLER_TRADER,
      }
    );
  }
);

const contentSelector = createSelector(traderContentSelector, ticketTraitsConvertSelector, (trader, ticketTraits) => {
  const result = [...ticketTraits];
  if (trader) {
    result.push(trader);
  }

  return result;
});

export {showBrokerInfoSelector, contentSelector, traderContentSelector, showBrokerInfoDSASelector};
